export default {
  getSSRProps() {
    // noop needed to be SSR compatible
    return {};
  },
  mounted(el, binding) {
    // Supports: v-intersect="{ class: ['fade-in'], threshold: 0.5, delay: 500 }"
    // Extract configuration from the binding value
    const config = binding.value || {};

    // Support an 'active' flag or just check if the value is falsy
    if (binding.value === false || config.active === false) {
      return;
    }

    const rawClass = config.class || "is-visible";
    const classes = Array.isArray(rawClass) ? rawClass : [rawClass];

    const threshold = config.threshold ?? 0.1;
    const rootMargin = config.margin || "0px";
    const delay = config.delay ?? 0;

    const options = {
      threshold,
      rootMargin,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Clear any existing timeout to prevent collisions
        if (el._intersectTimeout) {
          clearTimeout(el._intersectTimeout);
        }

        if (entry.isIntersecting) {
          el._intersectTimeout = setTimeout(() => {
            el.classList.add(...classes);

            if (!binding.modifiers.repeat) {
              observer.unobserve(el);
            }
          }, delay);
        } else if (binding.modifiers.repeat) {
          el.classList.remove(...classes);
        }
      });
    }, options);

    observer.observe(el);

    // Store references on the element for cleanup
    el._intersectObserver = observer;
  },

  unmounted(el) {
    if (el._intersectObserver) {
      el._intersectObserver.disconnect();
    }
    if (el._intersectTimeout) {
      clearTimeout(el._intersectTimeout);
    }
  },
};
